import DealByStatusCard from './DealByStatusCard.component';

export default DealByStatusCard;
